/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowServiceCatalogSubCategory {
    getFixupPrototypeFunction() { return ServiceNowServiceCatalogSubCategory.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowServiceCatalogSubCategory>): ServiceNowServiceCatalogSubCategory {
        let obj = Object.assign(new ServiceNowServiceCatalogSubCategory(), model);
        ServiceNowServiceCatalogSubCategory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowServiceCatalogSubCategory>): ServiceNowServiceCatalogSubCategory {
        if (!model) return null;
        return ServiceNowServiceCatalogSubCategory.newInstance(<ServiceNowServiceCatalogSubCategory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowServiceCatalogSubCategory) {
        if (!obj) return;

        models.ServiceNowServiceCatalogSubCategory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowServiceCatalogSubCategory): boolean {
        Object.setPrototypeOf(obj, ServiceNowServiceCatalogSubCategory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.sub_category) {
            models.ServiceNowRequestComponent.fixupPrototype(this.sub_category);
        }
        if (this.items) {
            for (let val of this.items) {
                models.ServiceNowRequestComponent.fixupPrototype(val);
            }
        }
    }

    sub_category: models.ServiceNowRequestComponent;

    /**
     * List of Service Catalog Items
     */
    items: Array<models.ServiceNowRequestComponent>;

}
